<template lang="pug">
  v-layout(row justify-center)
    v-flex(xs12 md8)
      v-card-title(class="py-4")
        h4(class="display-1 mx-auto font-weight-bold")  Редактирование подразделения
      v-card-text
        v-form(ref="form" @submit.prevent="create")
          span(:class="{'upperLine-error': hasError}").upperLine название подразделения
          v-text-field(
            v-bind:class="{'has-error': hasError}",
            :rules="nameRules",
            :error-messages="error",
            ref="name",
            outline,
            single-line,
            v-model="divisionName",
            autofocus,
            validate-on-blur,
            browser-autocomplete="off",
            class="pb-3")
          div(class="text-xs-center pb-3")
            v-btn(large @click.prevent="$router.go(-1)").mx-3 Отмена
            v-btn(large color="primary", :disabled="disabled", @click.prevent="edit").mx-3 Сохранить
</template>

<script>
import axios from 'axios/index'

export default {
  name: 'EditDivision',
  data: () => ({
    nameRules: [v => !!v || 'Необходимо ввести название подразделения'],
    name: '',
    disabled: true,
    hasError: false,
    error: ''
  }),
  watch: {
    name(val) {
      this.disabled = !val.length > 0
    },
    divisionName(val) {
      console.log(val)
    }
  },
  computed: {
    organisationId() {
      return this.$store.state.organisation.divisionItem.organisationId
    },
    divisionId() {
      return this.$store.state.organisation.divisionItem.id
    },
    divisionName: {
      get() {
        return this.$store.state.organisation.divisionItem.name
      },
      set(val) {
        this.name = val
      }
    }
  },
  methods: {
    edit() {
      if (this.$refs.form.validate()) {
        axios({
          method: 'PUT',
          url: `/api/Division/edit/${this.divisionId}`,
          data: {
            organisationId: this.organisationId,
            name: this.name
          }
        }).then(response => {
          this.$router.go(-1)
          this.hasError = false
          this.error = ''
        }).catch(error => {
          this.hasError = true
          this.error = error.response.data.message
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Division/EditDivision/EditDivision.vue